<template>
  <div v-if="obituaryHide">
    <div id="agree-wrap" v-if="!isAgreeObituary && !isRemove">
      <div class="button_wrap">
        <p>
          '개인정보 동의 후 부고 확인' 을 눌러 <br />
          <b @click="popup('/secure')">개인정보 수집 및 이용</b>에 동의합니다.
        </p>
        <button @click="handleAgreeObituary">개인정보 수집 및 이용 동의</button>
      </div>
    </div>
    <div v-else-if="getObituary" id="obituary">
      <div
        class="close_wrap"
        v-if="endModalFlag && isEndObituary"
        @click="endModalFlag = false"
      >
        <div class="logoArea">
          <img :src="require('../../assets/images/obituary/close_logo.webp')" />
        </div>
        <div class="logoArea2">해당 부고는 발인되었습니다</div>
        <button>닫기</button>
      </div>

      <!-- 각종 모달 넣기 -->
      <traffic-modal
        v-if="trafficFlag"
        :trafficType="trafficType"
        @close="trafficFlag = !trafficFlag"
      />
      <navi-modal
        v-if="naviFlag"
        @close="naviFlag = !naviFlag"
        :addrName="addr.name"
        :addr-x="addr.x"
        :addr-y="addr.y"
      />

      <!-- 영정사진 및 고인 정보 관련 -->
      <div v-if="exLogoFile" class="obituary-custom-logo">
        <img :src="exLogoFile.file_path" height="37px" />
      </div>
      <div v-else class="obituary-custom-logo">
        {{ (getObituary && getObituary.FUNERAL_NAME) + " " + (getObituary && getObituary.APPELLATION) }}
      </div>

      <header :class="{ noImg: !isObituaryPhoto }">
        <div class="photo-area" :class="{ noImg: !isObituaryPhoto }">
          <p>訃告</p>

          <div v-if="isObituaryPhoto" class="deceased-img__box">
            <img class="deceased-img" alt="" :src="obituaryPhotoPath" />
          </div>
        </div>
        <div class="deceased-info">
          <h4>
            <div>
              <span>故 {{ getObituary && getObituary.DM_NAME }}&nbsp;</span>
              <span v-if="getObituary && getObituary.DM_POSITION"
                >{{ getObituary.DM_POSITION }}&nbsp;
              </span>
            </div>
            <div>
              <span v-if="!isAgeViewDisable || !isGenderViewDisable"
                >(
                <span v-show="!isAgeViewDisable">
                  {{ getObituary.DM_AGE }}세
                </span>
                <span v-show="!isAgeViewDisable && !isGenderViewDisable">/</span>
                <span v-show="!isGenderViewDisable">
                  {{ getObituary.DM_GENDER_NAME }} </span
                >)</span
              >
            </div>
          </h4>
          <p v-if="isDieDate">{{ dieDateText }}</p>
        </div>
      </header>

      <section>
        <!--       
        <div v-if="getObituary && getObituary.CM_NAME" class="member-info__wraps">
          <div class="member-info__contents">
            <div class="members__wrap">
              <span class="member-type">대표상주</span>

              {{ obituaryMember.value }}  
              <div class="member-name__wrap">
                <span>{{ getObituary.CM_NAME }}</span>
              </div>
            </div>
          </div>

          <div class="divider"></div>
        </div>
        -->

        <div v-if="isFamilies" class="member-info__wraps">
          <h4 class="member-info__title">상주</h4>

          <div class="divider"></div>

          <div
            class="member-info__contents"
            v-if="
              (getObituaryUser && getObituaryUser.family_view_type === 0) ||
              !getObituaryUser
            "
          >
            <div
              v-for="(family, idx) in getFamilies"
              :key="idx"
              class="members__wrap"
            >
              <span class="member-type">{{ family.RELATION }}</span>

              <!-- {{ obituaryMember.value }} -->
              <div class="member-name__wrap">
                <span
                  v-for="(name, i) in family.NAMES.split(', ')"
                  :key="i"
                  :class="{
                    'empty-name':
                      name.includes('빈빈빈') || name.includes('빈빈'),
                  }"
                >
                  {{ name }}

                  <a
                    v-if="
                      getObituaryUsers.find(
                        (user) =>
                          user.user_name === name &&
                          user.user_category === family.RELATION
                      ) &&
                      getObituaryUsers.find(
                        (user) =>
                          user.user_name === name &&
                          user.user_category === family.RELATION
                      ).user_phone &&
                      getObituaryOption.phone_show
                    "
                    :href="`tel:${
                      getObituaryUsers.find(
                        (user) =>
                          user.user_name === name &&
                          user.user_category === family.RELATION
                      ).user_phone
                    }`"
                  >
                    <img
                      src="../../assets/images/obituary/phone-circle.svg"
                      alt="전화 이미지"
                    />
                  </a>

                  {{ family.NAMES.split(", ").length - 1 === i ? "" : "," }}
                </span>
              </div>
            </div>
          </div>

          <div class="member-info__contents" v-else>
            <div class="members__wrap">
              <span class="member-type">{{ getObituaryUser.user_category }}</span>
              <div class="member-name__wrap">
                <span>
                  {{ getObituaryUser.user_name }}
                  <a
                    v-if="
                      getObituaryUser.user_phone && getObituaryOption.phone_show
                    "
                    :href="`tel:${getObituaryUser.user_phone}`"
                  >
                    <img
                      src="../../assets/images/obituary/phone-circle.svg"
                      alt="전화 이미지"
                    />
                  </a>
                </span>
              </div>
            </div>
          </div>

          <div class="divider"></div>
        </div>

        <div class="obituary-info__wraps">
          <div class="obituary-info__wrap">
            <span class="obituary-info__title">빈소</span>

            <span class="obituary-info__content">
              {{ getObituary.FUNERAL_NAME + " " + binsoName }}
            </span>
          </div>

          <!--
          <div v-if="isFutureEntrance" class="obituary-info__wrap">
            <span class="obituary-info__title">입실</span>
            <span class="obituary-info__content">
              {{ entranceDate }} (예정)
            </span>
          </div>
          -->
          
          <div v-if="getObituary.CARRYING_FLAG === 1" class="obituary-info__wrap">
            <span class="obituary-info__title">입실</span>
            <span class="obituary-info__content">
              {{ entranceDate }}
            </span>
          </div>

          <div class="obituary-info__wrap">
            <span class="obituary-info__title">입관</span>
            <span class="obituary-info__content">
              {{ casketDate }}
            </span>
          </div>

          <div class="obituary-info__wrap">
            <span class="obituary-info__title">발인</span>

            <span class="obituary-info__content">
              {{ endDate }}
            </span>
          </div>

          <div class="obituary-info__wrap">
            <span class="obituary-info__title">장지</span>

            <span class="obituary-info__content" style="white-space: pre-line">
              {{ placeName }}
            </span>
          </div>

          <div v-if="obituaryNotice" class="obituary-info__wrap">
            <span class="obituary-info__title">알림글</span>
            <span class="obituary-info__contents" style="white-space: pre-line">
              {{ obituaryNotice }}
            </span>
          </div>
          <div class="address-call" v-if="getObituary.FUNERAL_NO === 523">
            <div>
              <p style="width: 100%; color:rgb(21, 34, 216); font-weight: bold;">{{ "주차장 안내: 라파엘웰빙센터 주차장(국화원장례식장 맞은편)" }}</p>
            </div>
          </div>
        </div>
      </section>
      <div class="divider__2"></div>
      <section class="obituary-map__wrap">
        <div class="map__title"><h4>오시는 길</h4></div>

        <h4 v-if="isDisableMap" class="disable__text">
          지도를 표시할 수 없습니다
        </h4>
        <kakao-map v-else :addr-x="addr.x" :addr-y="addr.y" />

        <div class="map-info">
          <ul>
            <li @click="handleTrafficModal('parking')">
              <span>주차·교통안내</span>
            </li>
            <li @click="handlePublicTrafficOpen()">
              <span>위치확인</span>
            </li>

            <li @click="naviFlag = true">
              <span>네비게이션</span>
            </li>
          </ul>
        </div>

        <div class="address-call">
          <div>
            <div class="call__wrap">
              <h5>{{ addr.name }}</h5>
              <a :href="`tel:${addr.call}`" v-if="!exHomepage">
                <img
                  src="../../assets/images/obituary/phone.svg"
                  alt="phoneIcon"
                />
              </a>
            </div>
            <p>{{ addr.fullAddr }}</p>
          </div>
          <button @click="copyAddr(addr.fullAddr)">주소복사</button>
        </div>
        <div v-if="exHomepage" class="funeral_buttons">
          <button class="open-homepage" @click="handleOpenHomepage">
            홈페이지 이동
          </button>
          <a class="call-inquiry" :href="`tel:${addr.call}`">전화문의</a>
        </div>
      </section>
      <div class="px-4">
        <banner-swiper v-if="exBannerFiles" />
      </div>
      <div class="divider__2"></div>

      <section class="obituary-service__wrap" v-if="getObituary.WREATH_SHOW_FLAG === 1">
        <obituary-letter
          v-if="this.getObituary.EVENT_NO !== 581574"
          :obituaryMessages="obituaryCommentList"
          @handleViewLetter="letterListFlag = true"
          @handleRegistLetter="letterListFlag = 'regist'"
          @handleEditFlag="handleEditFlag"
        />
        <obituary-wreath
          v-if="this.getObituary.FUNERAL_NO !== 1315"
          :obituaryWreaths="wreathCommentList"
          @handleViewWreath="wreathListFlag = !wreathListFlag"
          @goShop="goShop"
        />
      </section>

      <div class="functions-card">
        <button
          v-if="getObituaryFuneral && getObituaryFuneral.FLOWER_BLIND_FLAG !== 2 && getObituary.EVENT_NO !== 576569"
          @click="goShop"
        >
          근조 화환
        </button>
        <button
          v-show="getObituaryAccountList && getObituaryAccountList.length !== 0"
          @click="checkAccoutList"
        >
          조의금
        </button>
        <button @click="handleShareBugo">부고 전달</button>
      </div>

      <v-bottom-sheet v-model="accountViewFlag" inset>
        <v-sheet height="auto">
          <account-list
            :accountViewFlag="accountViewFlag"
            @close="accountViewFlag = !accountViewFlag"
          />
        </v-sheet>
      </v-bottom-sheet>

      <v-bottom-sheet v-model="bugoShareSnsFlag" inset>
        <v-sheet class="text-center" height="auto">
          <sns-list @close="bugoShareSnsFlag = !bugoShareSnsFlag" />
        </v-sheet>
      </v-bottom-sheet>

      <obituary-msg-list
        v-if="letterListFlag"
        :letterListFlag="letterListFlag"
        :obituary-msg="obituaryCommentList"
        @close="letterListFlag = false"
        @handleEditFlag="handleEditFlag"
      />

      <v-bottom-sheet v-model="passwordFlag" inset>
        <v-sheet height="auto">
          <div class="bottom-modal__wrap">
            <div class="pb-4">
              <h4>등록 시 입력한 비밀번호를 입력하세요</h4>
            </div>
            <div class="bottom-modal__content">
              <v-text-field
                v-model="COMMENT_PASSWORD"
                hide-details
                outlined
                dense
                type="password"
                color="main"
                placeholder="등록 시 사용한 비밀번호를 입력"
                @keyup.enter="handleCheckPassword"
              ></v-text-field>
            </div>
            <div class="bottom-modal-button__wrap">
              <div class="bottom-modal-button close" @click="handleEditInit">
                닫기
              </div>
              <div class="bottom-modal-button apply" @click="handleCheckPassword">
                확인
              </div>
            </div>
          </div>
        </v-sheet>
      </v-bottom-sheet>

      <v-bottom-sheet v-model="editCommentFlag" inset>
        <v-sheet height="auto">
          <div class="bottom-modal__wrap">
            <div
              class="pb-4"
              style="display: flex; justify-content: space-between"
            >
              <h4 class="edit-msg__title">추모의 글 수정</h4>
              <button class="delete-msg" @click="handleDeleteObituaryComment">
                삭제
              </button>
            </div>

            <h6>보내는 분</h6>
            <v-text-field
              v-model="targetObituaryComment.NAME"
              outlined
              dense
              hide-details
              type="text"
              color="main"
              placeholder="성함을 입력하세요"
            ></v-text-field>
            <h6 class="pt-2">비밀번호</h6>
            <v-text-field
              v-model="targetObituaryComment.COMMENT_PASSWORD"
              hide-details
              outlined
              dense
              :type="passwordFieldType"
              color="main"
              placeholder="수정 시 사용할 비밀번호를 입력"
              append-icon="mdi-eye"
              @click:append="togglePasswordVisibility"
            ></v-text-field>
            <h6 class="pt-2">추모 메시지</h6>
            <v-textarea
              v-model="targetObituaryComment.COMMENT_NO"
              outlined
              height="218px"
              counter="100"
              color="main"
              placeholder="삼가 고인의 명복을 빕니다"
            ></v-textarea>

            <div class="bottom-modal-button__wrap">
              <div class="bottom-modal-button close" @click="handleEditInit">
                닫기
              </div>
              <div
                class="bottom-modal-button apply"
                @click="handleEditObituaryComment"
              >
                저장
              </div>
            </div>
          </div>
        </v-sheet>
      </v-bottom-sheet>

      <obituary-wreath-list
        v-if="wreathListFlag"
        :obituary-wreath="wreathCommentList"
        @close="wreathListFlag = !wreathListFlag"
      />
    </div>
  </div>
</template>

<script>
import KakaoMap from "../../components/Obituary/KakaoMap.vue";
import NaviModal from "../../components/Obituary/NaviModal.vue";
import TrafficModal from "../../components/Obituary/TrafficModal.vue";
import ObituaryLetter from "../../components/Obituary/ObituaryLetter.vue";
import ObituaryWreath from "../../components/Obituary/ObituaryWreath.vue";
import ObituaryMsgList from "../../components/Obituary/ObituaryMsgList.vue";
import ObituaryWreathList from "../../components/Obituary/ObituaryWreathList.vue";
import SnsList from "../../components/Obituary/SnsList.vue";
import AccountList from "../../components/Obituary/AccountList.vue";
import { mapGetters } from "vuex";
import BannerSwiper from "../../components/Obituary/BannerSwiper.vue";
export default {
  components: {
    KakaoMap,
    NaviModal,
    TrafficModal,
    ObituaryLetter,
    ObituaryWreath,
    ObituaryMsgList,
    ObituaryWreathList,
    SnsList,
    AccountList,
    BannerSwiper,
  },
  name: "ObituaryPage",

  data() {
    return {
      agreeFlag: false,
      endModalFlag: true,
      eventNo: this.$route.query.event_no ? this.$route.query.event_no : null,
      seqNo: this.$route.query.seq_no ? this.$route.query.seq_no : null,
      eventObiutary: null,

      // modal flag 모음
      naviFlag: false,
      trafficFlag: false,
      trafficType: "bus",
      bugoShareSnsFlag: false,
      letterListFlag: false,
      wreathListFlag: false,
      accountViewFlag: false,

      passwordFlag: false,
      editCommentFlag: false,
      targetObituaryComment: {
        NAME: "",
        COMMENT_PASSWORD: "",
        COMMENT_NO: "",
      },
      COMMENT_PASSWORD: "",
      passwordVisible: false,
      isRemove: false,
    };
  },

  computed: {
    ...mapGetters([
      "getObituary",
      "getObituaryOption",
      "getObituaryUser",
      "getObituaryUsers",
      "getFamilies",
      "getObituaryComment",
      "getObituaryAccountList",
      "getObituaryFuneral",
      "getLoadingStatus",
    ]),

    exPhotoReplaceFile() {
      const customFiles =
        this.getObituaryFuneral?.RaspberryConnections[0]?.CUSTOM_FILE_PATH;

      if (!customFiles) {
        return null;
      }

      return customFiles;
    },

    isAgreeObituary() {
      if (this.eventNo) return true;

      if (this.agreeFlag) return true;

      // 모바일 버전일때만 동의 검증
      const userAgent = window.navigator.userAgent;
      if (
        userAgent.indexOf("iPhone") > -1 ||
        userAgent.indexOf("Android") > -1
      ) {
        return this.getObituaryUser?.agree_dt;
      } else {
        return true;
      }
    },

    isObituaryPhoto() {
      return (
        this.getObituaryOption?.photo_show &&
        (this.getObituary?.DM_PHOTO || this.exPhotoReplaceFile)
      );
    },
    obituaryPhotoPath() {
      // return this.obituaryDetail.Files[0].filePath
      return this.getObituary?.DM_PHOTO || this.exPhotoReplaceFile;
    },
    isAgeViewDisable() {
      // 노출 이어도, 나이가 없으면 안됌
      // 나이가 있어도 미노출이면 가리기
      return !(
        this.getObituary?.DM_AGE?.trim() && this.getObituaryOption?.age_show
      );
    },

    isGenderViewDisable() {
      return !(
        this.getObituaryOption?.gender_show &&
        this.getObituary?.DM_GENDER_NAME?.trim()
      );
    },

    isDieDate() {
      return this.getObituaryOption?.dead_dt_show && this.getObituary?.DEAD_DT;
    },

    dieDateText() {
      return `${this.PRINTYYMMDDDate(this.getObituary?.DEAD_DT) || ""} ${
        this.getObituary?.DEAD_CLASSIFY || ""
      }`;
    },

    isFamilies() {
      return this.getFamilies?.length > 0;
    },

    // 빈소명
    binsoName() {
      return (
        this.getObituary?.APPELLATION_TEXT ||
        this.getObituary?.APPELLATION ||
        this.getObituary?.BINSO_NAME ||
        ""
      );
    },
    // 입실 예정인 지
    isFutureEntrance() {
      if (!this.getObituary?.ENTRANCE_ROOM_DT) {
        return false;
      }

      const now = new Date();
      const entranceDate = new Date(this.getObituary?.ENTRANCE_ROOM_DT);

      return entranceDate > now;
    },

    entranceDate() {
      const formattedDate = this.getObituary.ENTRANCE_ROOM_DT.replace(
        "요일",
        ""
      );
      return this.KOREAYYYYMMDDEEHHMMDate(formattedDate);
    },

    // 입관일
    casketDate() {
      if (this.getObituary?.IPGWAN_YN == 0) {
        return "미정";
      }

      if (this.getObituary?.ENTRANCE_ROOM_START_DT) {
        const formattedDate = this.getObituary.ENTRANCE_ROOM_START_DT.replace(
          "요일",
          ""
        );
        return this.KOREAYYYYMMDDEEHHMMDate(formattedDate);
      }

      return "미정";
      // return this.getObituary?.ENTRANCE_ROOM_START_DT
      //   ? this.KOREAYYYYMMDDEEHHMMDate(
      //       this.getObituary?.ENTRANCE_ROOM_START_DT.replace("요일", "")
      //     )
      //   : "미정";
    },

    isEndObituary() {
      if (this.getObituary?.CARRYING_DT) {
        const endDate = new Date(this.getObituary?.CARRYING_DT);

        // Get the current time
        const currentTime = new Date();

        if (endDate < currentTime) return true;
      }

      return false;
    },

    obituaryHide() {
      if (this.getObituary?.CARRYING_DT) {
        const endDate = new Date(this.getObituary?.CARRYING_DT);
        const extendedDate = new Date(endDate.getTime() + 30 * 24 * 60 * 60 * 1000);
        const currentTime = new Date();
        if (extendedDate < currentTime) {
          alert('해당 부고장은 발인 후 30일이 지나 만료되었습니다.');
          return false;
        }
      }
      return true;
    },

    endDate() {
      return this.getObituary?.CARRYING_DT && this.getObituary?.CARRYING_YN
        ? this.KOREAYYYYMMDDEEHHMMDate(
            this.getObituary?.CARRYING_DT.replace("요일", "")
          )
        : "미정";
    },

    placeName() {
      return this.getObituary?.BURIAL_PLOT_NAME?.trim() !== ""
        ? this.getObituary?.BURIAL_PLOT_NAME
        : "미정";
    },

    isDisableMap() {
      return !this.getObituary?.LAT && !this.getObituary?.LNG;
    },

    addr() {
      return {
        fullAddr: this.getObituary?.ADDRESS,
        x: this.getObituary?.LNG,
        y: this.getObituary?.LAT,
        call: this.getObituary?.CONTACT,
        name: this.getObituary?.FUNERAL_NAME,
      };
    },

    obituaryNotice() {
      if (this.getObituaryUser && this.getObituaryUser.user_notice) {
        return this.getObituaryUser.user_notice;
      } else if (this.getObituary && this.getObituary.STORE_INFO) {
        return this.getObituary.STORE_INFO;
      }

      return "";
    },

    obituaryCommentList() {
      return this.getObituaryComment?.length > 0
        ? this.getObituaryComment?.filter(
            (comment) => comment.USER_FLAG == 1 || comment.USER_FLAG == 3
          )
        : [];
    },
    wreathCommentList() {
      return this.getObituaryComment?.length > 0
        ? this.getObituaryComment?.filter((comment) => comment.USER_FLAG == 2)
        : [];
    },

    // 커스텀 영역
    exLogoFile() {
      const customFiles = this.getObituaryFuneral?.FuneralCustomFiles;

      if (!customFiles) {
        return null;
      }
      if (customFiles && customFiles?.length !== 0) {
        const logoFiles = customFiles?.filter((v) => v.custom_type == 1)[0];

        return logoFiles;
      } else {
        return null;
      }
    },

    exBannerFiles() {
      const customFiles = this.getObituaryFuneral?.FuneralCustomFiles;
      if (!customFiles) {
        return null;
      }
      if (customFiles && customFiles?.length !== 0) {
        const bannerFile = customFiles.filter((v) => v.custom_type == 2);

        return bannerFile;
      } else {
        return null;
      }
    },

    exHomepage() {
      return this.getObituaryFuneral?.HOMEPAGE;
    },

    passwordFieldType() {
      return this.passwordVisible ? "text" : "password";
    },
  },

  beforeCreate() {
    this.$store.commit("START_LOADING");
  },
  mounted() {
    // 행사 번호로 정보 조회
    if (!this.eventNo && !this.seqNo) {
      alert("행사 정보가 존재하지 않는 부고입니다");
      return;
    }
    this.$store
      .dispatch("REQUEST_GET_OBITUARY", {
        event_no: this.eventNo,
        seq_no: this.seqNo,
      })
      .then((res) => {
        if (!res) {
          this.isRemove = true;
          alert("행사 정보가 존재하지 않는 부고입니다");
          return;
        }
      });

    this.$nextTick(() => {
      this.$store.commit("END_LOADING");
    });
  },

  methods: {
    popup(path) {
      window.open(`${process.env.VUE_APP_POPUP_BASEURL}${path}`);
    },
    async handleAgreeObituary() {
      await this.$store
        .dispatch(`REQUEST_OBITUARY_AGREE`, {
          seq_no: this.seqNo,
        })
        .then((data) => {
          if (!data) return;

          alert(
            `개인정보 동의가 완료되었습니다. (동의일시 :${this.KOREAYYYYMMDDEEHHMMDate(
              data.eventUser.agree_dt
            )})`
          );

          this.agreeFlag = true;
        });
    },
    handlePublicTrafficOpen() {
      const { FUNERAL_NAME, LAT, LNG } = this.getObituary;

      window.open(
        `https://map.kakao.com/link/map/${FUNERAL_NAME},${LAT},${LNG}`
      );
    },
    handleTrafficModal(trafficType) {
      this.trafficType = trafficType;
      this.trafficFlag = true;
    },

    handleNaviModal() {
      this.naviFlag = !this.naviFlag;
    },

    async goShop() {
      //발인일이, 현재 시간 보다 과거일 경우도 막고 싶어
      if (this.isEndObituary) {
        alert("해당 부고는 발인 되어 주문이 불가능 합니다");
        return;
      }

      if (this.getObituaryFuneral?.FLOWER_BLIND_FLAG == 3) {
        window.location.href = `tel:${this.getObituaryFuneral.FLOWER_CUSTOM_CALL}`;

        return;
      }

      this.$router.push({
        path: "/obituary/shop",
        query: {
          ...this.$route.query,
        },
      });
    },

    copyAddr(addr) {
      if (!document.queryCommandSupported("copy")) {
        return alert("복사하기가 지원되지 않는 브라우저입니다.");
      }

      const textarea = document.createElement("textarea");
      textarea.value = addr;
      textarea.style.top = 0;
      textarea.style.left = 0;
      textarea.style.position = "fixed";

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("클립보드에 복사되었습니다.");
    },

    checkAccoutList() {
      this.accountViewFlag = !this.accountViewFlag;
    },

    handleShareBugo() {
      this.bugoShareSnsFlag = !this.bugoShareSnsFlag;
    },

    handleEditInit() {
      this.targetObituaryComment = {
        NAME: "",
        COMMENT_PASSWORD: "",
        COMMENT_NO: "",
      };
      this.COMMENT_PASSWORD = "";
      this.passwordFlag = false;
      this.editCommentFlag = false;
    },
    handleEditFlag(obituaryComment) {
      this.targetObituaryComment = obituaryComment;
      this.passwordFlag = true;
    },

    async handleCheckPassword() {
      if (this.COMMENT_PASSWORD) {
        await this.$store
          .dispatch(`REQUEST_OBITUARY_COMMENT_PWD_CHECK`, {
            COMMENT_PASSWORD: this.COMMENT_PASSWORD,
            OBITUARY_COMMENT_NO: this.targetObituaryComment.OBITUARY_COMMENT_NO,
          })
          .then((data) => {
            // const result = data.result;
            if (!data) return;

            this.editCommentFlag = true;
            this.COMMENT_PASSWORD = "";
            this.passwordFlag = false;
          });
      }
    },

    async handleEditObituaryComment() {
      try {
        const {
          OBITUARY_COMMENT_NO,
          NAME,
          COMMENT_PASSWORD,
          COMMENT_NO,
          EVENT_NO,
        } = this.targetObituaryComment;
        if (!NAME) {
          return alert("성함을 입력하여 주십시요");
        }

        if (!COMMENT_PASSWORD.trim()) {
          return alert("비밀번호를 입력하여 주십시요");
        }
        if (!COMMENT_NO) {
          return alert("내용을 입력하여 주십시요");
        }

        if (COMMENT_NO.length > 100) {
          alert("추모 메시지는 100자를 초과할 수 없습니다.");
          return;
        }

        const parameter = {
          OBITUARY_COMMENT_NO,
          EVENT_NO,
          NAME,
          COMMENT_NO,
          COMMENT_PASSWORD,
        };
        await this.$store
          .dispatch(`REQUEST_UPDATE_OBITUARY_COMMENT`, parameter)
          .then((data) => {
            // const result = data.result;

            if (!data) return;

            this.handleEditInit();
          });
      } catch (error) {
        console.error(error);
      }
    },

    handleDeleteObituaryComment() {
      const { OBITUARY_COMMENT_NO } = this.targetObituaryComment;

      if (confirm("해당 추모 메시지를 삭제하시겠습니까?")) {
        this.$store
          .dispatch("REQUEST_DELETE_OBITUARY_COMMENT", {
            OBITUARY_COMMENT_NO,
          })
          .then((res) => {
            if (!res) return;

            alert("삭제 되었습니다.");

            this.$router.go();
          });
      }
    },
    handleOpenHomepage() {
      let homepageUrl = this.exHomepage;

      if (!homepageUrl.match(/^(http:\/\/|https:\/\/)/)) {
        homepageUrl = "http://" + homepageUrl;
      }

      window.location.href = homepageUrl;
    },

    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
};
</script>

<style></style>
